export default __webpack_public_path__ + "static/media/monitor.183c23db.png";